import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'add_payment_method';
export const route = 'renewal/add_payment_method/[crmToken]';
export const AddPaymentMethodPage = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "add_payment_method" */
/* webpackPrefetch: true */
'../../components/Prime/AddPaymentMethodPage')));